import moment from 'moment';
import { statisticType } from '@/constants/statistic';

/* eslint-disable import/prefer-default-export */
export function getStatisticType(startDatetime, endDatetime) {
  let type;
  const diff = moment(endDatetime).diff(startDatetime, 'd');
  if (diff <= 3) {
    type = statisticType.DAY;
  } else if (diff <= 19) {
    type = statisticType.WEEK;
  } else if (diff <= 90) {
    type = statisticType.MONTH;
  } else {
    type = statisticType.YEAR;
  }
  return type;
}



// WEBPACK FOOTER //
// ./src/utils/statistic.js